export const GENDER_CODES = ['m', 'f', 'u', 'o'] as const;
export type GenderCode = (typeof GENDER_CODES)[number];

export const GENDER_CODE_MAP: Record<GenderCode, string> = {
  m: 'Male',
  f: 'Female',
  u: 'Unknown',
  o: 'Other',
} as const;
